import { rangeFilter } from './filters'

import type { RangeClause } from '../types/query'

export { rangeFilter }

/**
 * Build an `@timestamp` range clause from absolute ISO bounds.
 */
export function timestampRange(st: string, ed: string): RangeClause {
	return rangeFilter('@timestamp', { gte: st, lte: ed })
}
